var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBasket = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 22",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.479 5.74v-1.9h-7.796V.333H8.336V3.84H.47v1.808a4.332 4.332 0 0 0-.003.17V16.85c0 1.349.433 2.856 1.484 3.755 1.02.9 2.36 1.06 3.667 1.06H14.338c3.25 0 5.138-1.482 5.14-4.851l.002-10.988-.001-.088Zm-15.2 12.23c-.542-.546-.702-1.285-.702-2.024 0 0 0-6.76-.002-8.996H5.79v11.592c-.577-.022-1.064-.122-1.51-.571Zm6.814.58h-2.21l.001-11.6h2.21v11.6Zm5.316-2.551c0 1.709-.79 2.424-2.223 2.55V6.95h2.223V16Z",
  fill: "currentColor",
  fillRule: "nonzero"
})));
export default SvgBasket;